
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        // Prefer cart drawer when enabled
        this.cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        this.submitButton = this.querySelector('[type="submit"]');

        if (this.cart && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.error = false;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        try {
          // STEP 1: Add product to Shopify cart

          const response = await fetch(
            routes.cart_add_url,
            {
              ...config,
              body: formData
            }
          );

          const responseData = await response.json();

          if (!response.ok || responseData.status) {
            const errorMessage =
              responseData.description ||
              responseData.message ||
              'Unable to add product to cart.';

            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: responseData.errors || errorMessage,
              message: errorMessage
            });

            this.handleErrorMessage(errorMessage);

            this.error = true;

            return;
          }

          this.error = false;

          // STEP 2: Handle theme without cart drawer

          if (!this.cart) {
            window.location.href = window.routes.cart_url;
            return;
          }

          // STEP 3: Request fresh cart drawer HTML

          const sectionIds = this.cart.getSectionsToRender().map(
            (section) => section.id
          );

          const sectionUrl = new URL(
            window.Shopify.routes.root,
            window.location.origin
          );

          sectionUrl.searchParams.set(
            'sections',
            sectionIds.join(',')
          );

          const sectionResponse = await fetch(
            sectionUrl.toString(),
            {
              method: 'GET',
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!sectionResponse.ok) {
            throw new Error('Unable to refresh cart drawer.');
          }

          const sections = await sectionResponse.json();

          // STEP 4: Validate section HTML

          const missingSections = sectionIds.filter(
            (id) => typeof sections[id] !== 'string'
          );

          if (missingSections.length > 0) {
            console.error(
              'MAY & CO. Missing cart sections:',
              missingSections,
              sections
            );

            throw new Error(
              'Cart was updated, but the cart drawer could not be refreshed.'
            );
          }

          // STEP 5: Publish cart update

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: responseData
          });

          // STEP 6: Render drawer

          const renderCart = () => {
            this.cart.renderContents({
              ...responseData,
              sections: sections
            });
          };

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(renderCart, 100);
              },
              { once: true }
            );

            quickAddModal.hide(true);

          } else {
            renderCart();
          }

        } catch (error) {
          console.error(
            'MAY & CO. Product Form Cart Error:',
            error
          );

          this.handleErrorMessage(error.message);

        } finally {
          this.submitButton.classList.remove('loading');

          if (
            this.cart &&
            this.cart.classList.contains('is-empty') &&
            this.error === false
          ) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) {
            spinner.classList.add('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
